import { gql } from '@apollo/client';
import { OrderType } from '../../../../graphql/types/OrderType';
import { DamagedParcelFiltersInput } from '../../types/damagedLabelLookupTypes';

/** 结果表展示所需字段 */
export const DAMAGED_LABEL_LOOKUP_ORDER_FIELDS = `
    id
    trackingNumber
    channelId
    channelOrderNumber
    senderFullName
    senderAddressText
    senderPostalCode
    recipientFullName
    recipientAddressText
    receiverZipcode
    overallStatus
    prePickupHubName
    pickupHubName
    sortingCode
`;

export const GET_DAMAGED_PARCEL_LISTING_FOR_CENTRAL = gql`
    query GetDamagedParcelListingForCentral(
        $filters: DamagedParcelFiltersTypeInput!
        $pageRequest: PageRequestTypeInput
    ) {
        getDamagedParcelListingForCentral(filters: $filters, pageRequest: $pageRequest) {
            content {
                ${DAMAGED_LABEL_LOOKUP_ORDER_FIELDS}
            }
            totalElements
            accessiblePages
        }
    }
`;

export const GET_DAMAGED_PARCEL_LISTING_FOR_WMS = gql`
    query GetDamagedParcelListingForWMS(
        $filters: DamagedParcelFiltersTypeInput!
        $pageRequest: PageRequestTypeInput
    ) {
        getDamagedParcelListingForWMS(filters: $filters, pageRequest: $pageRequest) {
            content {
                ${DAMAGED_LABEL_LOOKUP_ORDER_FIELDS}
            }
            totalElements
            accessiblePages
        }
    }
`;

export interface DamagedParcelListingResponse {
    content: OrderType[];
    totalElements: number;
    accessiblePages?: number | null;
}

export interface GetDamagedParcelListingForCentralResponse {
    getDamagedParcelListingForCentral: DamagedParcelListingResponse;
}

export interface GetDamagedParcelListingForWMSResponse {
    getDamagedParcelListingForWMS: DamagedParcelListingResponse;
}

export interface DamagedParcelListingVariables {
    filters: DamagedParcelFiltersInput;
    pageRequest: {
        page: number;
        size: number;
    };
}
